<template>
  <div class="messages__request">
    <div class="messages--temporary" v-if="isHandled">
      <lennoc-icon image="check--large" />
      <span>{{ getUiString(['advanced', 'claim_submitted']) }}</span>
      <a v-if="!!linkedClaim" class="link link--edit link--view" @click="viewClaim">
        <lennoc-icon image="eye" />
        <span>{{ getUiString(['advanced', 'view_claim']) }}</span>
      </a>
    </div>
    <base-button-group
      v-if="!isHandled"
      :buttons="claimRequestButtons"
      :markClicked="true"
      @button-click="handleClaimRequest"
      :disabled="isSubmitted"
    ></base-button-group>
    <lennoc-spinner v-if="busy"></lennoc-spinner>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ClaimRequestItem',
  data () {
    return {
      busy: false,
      isSubmitted: false
    }
  },
  props: {
    isHandled: {
      type: Boolean,
      required: true
    },
    linkedClaim: {
      type: String,
      default () {
        return ''
      }
    }
  },
  computed: {
    ...mapGetters({
      claim: 'claim/currentClaim',
      getUiString: 'uistrings/getUiString'
    }),
    claimRequestButtons () {
      return [
        { id: 'but_extracost_yes', text: this.getUiString(['general', 'yes']) },
        { id: 'but_extracost_no', text: this.getUiString(['general', 'no']) }
      ]
    }
  },
  methods: {
    handleClaimRequest (button) {
      this.isSubmitted = button === 'but_extracost_yes'
      if (this.isSubmitted) {
        const calcUrl = this.claim.ClaimType !== 'Regulation_261_2004'
          ? '/check-uw-vlucht?Action=RelatedClaim&Value=' + this.claim.Id
          : '/krijg-uw-extra-gemaakte-kosten-terug?Action=RelatedClaim&Value=' + this.claim.Id

        window.open(calcUrl, '_blank')
      }
      this.$emit('claim-submitted')
    },
    viewClaim () {
      if (this.linkedClaim) {
        this.busy = true
        this.$store.dispatch('claim/initializeClaim', this.linkedClaim)
          .finally(() => { this.busy = false })
      }
    }
  }
}
</script>
